import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import productService from '../services/productService';
import { useAuth } from '../context/AuthContext';
import { PageHeader } from '@/components/ui/page-header';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Separator } from '@/components/ui/separator';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const ProductDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { token } = useAuth();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    productService.getProducts(token)
      .then(products => {
        const found = products.find(p => p.id === id);
        setProduct(found);
      })
      .catch(setError)
      .finally(() => setLoading(false));
  }, [id, token]);

  if (loading) {
    return <p className="text-muted-foreground">Loading...</p>;
  }
  if (error) {
    return <p className="text-destructive">{error.message || 'Error loading product'}</p>;
  }
  if (!product) {
    return <p className="text-muted-foreground">Product not found.</p>;
  }

  const DetailRow = ({ label, children }) => (
    <div className="space-y-1">
      <p className="text-sm text-muted-foreground">{label}</p>
      <div className="text-sm font-medium text-foreground">{children}</div>
    </div>
  );

  return (
    <div className="mx-auto max-w-xl space-y-4">
      <PageHeader
        title={product.product_name}
        actions={
          <Button variant="outline" onClick={() => navigate(-1)}>
            Back
          </Button>
        }
      />

      <Card>
        <CardHeader>
          <CardTitle>Product details</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <DetailRow label="Description">{product.description || '-'}</DetailRow>
          <DetailRow label="Category">{product.category || '-'}</DetailRow>
          <DetailRow label="Price">{product.original_price}</DetailRow>
          <DetailRow label="Available">
            <Badge variant={product.is_available ? 'success' : 'secondary'}>
              {product.is_available ? 'Yes' : 'No'}
            </Badge>
          </DetailRow>
          <DetailRow label="Stock Quantity">{product.stock_quantity}</DetailRow>
          <DetailRow label="Created At">{product.created_at}</DetailRow>
          <DetailRow label="Updated At">{product.updated_at}</DetailRow>

          <Separator />

          <h2 className="text-lg font-semibold">Merchant Info</h2>
          <DetailRow label="Business Name">{product.merchants?.business_name || '-'}</DetailRow>
          <DetailRow label="Email">{product.merchants?.email || '-'}</DetailRow>
          <DetailRow label="Merchant ID">{product.merchant_id}</DetailRow>
        </CardContent>
      </Card>
    </div>
  );
};

export default ProductDetails;
